import React from 'react';
import Layout from '../../components/UI/Layout/Layout' 
import PermissionList from '../../components/Entity/Permissions/List/List';
 
const PermissionsPage = () => {
  return <Layout nonav={0} fullwidth={0}>
       <PermissionList></PermissionList>
    
  </Layout>;
}

export default PermissionsPage;